import Text from "./input/Text"

export default Text
